import { useTranslation } from 'react-i18next'
import ContactForm from '../components/ContactForm'
import CompanyInfoModalContent from '../components/CompanyInfoModal'

function ContactPage() {
  const { t } = useTranslation()

  return (
    <div>
      <div className='text-center w-full align-middle bg-redpink text-white lg:mb-5 pb-3 pt-3'>
        <h1 className='uppercase text-base sm:text-xl lg:text-2xl'>
          {t('contact-us')}
        </h1>
        <h2 className='px-2 lg:px-0 text-xs sm:text-sm lg:text-md'>
          {t('contact-description')}
        </h2>
      </div>

      <div className='max-w-7xl mx-auto '>
        <div className='flex flex-col lg:flex-row lg:gap-8 mb-5'>
          <div className='w-full lg:w-2/3'>
            <ContactForm
              variant='white'
              showInfoButton={false}
              className='rounded-lg'
              showTitle={false}
            />
          </div>

          <div className='w-full lg:w-1/3 px-2 lg:px-0'>
            <div className='bg-grisclair rounded-lg overflow-hidden lg:mb-5 lg:mt-5'>
              <CompanyInfoModalContent onClose={() => {}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactPage
